import userProfileType from "../type/user-profile.type"

export default [
  {
    title: userProfileType.individual.title,
    field: userProfileType.individual.value,
    options: userProfileType.individual.value,
  },
  {
    title: userProfileType.legal.title,
    field: userProfileType.legal.value,
    options: userProfileType.legal.value,
  },
]